var map = {
	"./template.bet777": 1027,
	"./template.bet777.tsx": 1027,
	"./template.betprofessor": 1028,
	"./template.betprofessor.tsx": 1028,
	"./template.betroyale": 1029,
	"./template.betroyale.tsx": 1029,
	"./template.buffalobet": 1030,
	"./template.buffalobet.tsx": 1030,
	"./template.default": 650,
	"./template.default.tsx": 650,
	"./template.fiestabet": 1031,
	"./template.fiestabet.tsx": 1031,
	"./template.forsport": 1032,
	"./template.forsport.tsx": 1032,
	"./template.goldenrush": 1033,
	"./template.goldenrush.tsx": 1033,
	"./template.oldgill": 1034,
	"./template.oldgill.tsx": 1034,
	"./template.puntcity": 1035,
	"./template.puntcity.tsx": 1035,
	"./template.puntgenie": 1036,
	"./template.puntgenie.tsx": 1036,
	"./template.questbet": 1037,
	"./template.questbet.tsx": 1037,
	"./template.ts": 961,
	"./template.volcanobet": 1038,
	"./template.volcanobet.tsx": 1038,
	"./template.wellbet": 1039,
	"./template.wellbet.tsx": 1039
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2317;